import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { environment } from '@env/environment';
import { Logger, AuthenticationService, untilDestroyed, CredentialsService } from '@app/core';
import { LoaderComponent } from '@app/shared/loader/loader.component';
import { LanguageOption, LanguageService } from '@app/core/language/language.service';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModule } from '@app/material.module';

const log = new Logger('Login');

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
    LoaderComponent,
    MaterialModule
  ]
})
export class LoginComponent implements OnInit, OnDestroy {
  version: string | null = environment.version;
  error: string | undefined;
  loginForm!: FormGroup;
  isLoading = false;
  hide: boolean = true;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private languageService: LanguageService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog
  ) {
    this.createForm();
  }
  ngOnInit() {}
  ngOnDestroy() {}

  login() {
    this.isLoading = true;
    const login$ = this.authenticationService.login(this.loginForm.value);
    login$
      .pipe(
        finalize(() => {
          this.loginForm.markAsPristine();
          this.isLoading = false;
        }),
        untilDestroyed(this)
      )
      .subscribe({
        next: credentials => {
          log.debug(`${credentials.username} successfully logged in`);
          this.error = '';
          // Redirect to dashboard or the originally requested page
          this.router.navigate(['/dashboard'], { replaceUrl: true });
        },
        error: err => {
          const error = err.error;
          if (error.code === 2006) {
            this.error = error.message;
          }
          log.debug(`Login error: ${error}`);
          log.debug(error);
          if (error && error.errors) {
            if (error.errors.email) {
              // this.loginForm.controls['password'].setErrors({ password: true });
              this.error = error.errors.email[0];
            } else if (error.errors.username) {
              // this.loginForm.controls['username'].setErrors({ username: true });
              this.error = error.errors.username[0];
            } else {
              // this.loginForm.controls['password'].setErrors({ password: true });
              if (error.errors.password.length) {
                this.error = error.errors.password[0];
              }
            }
          } else {
            this.error = 'خطا في البريد الالكتروني او كلمة المرور';
          }
        }
      });
  }

  setLanguage(lang: { value: string; label: string; flag: string }) {
    this.languageService.setLanguage(lang.value);
  }

  get isEnglish(): boolean {
    return this.languageService.isEnglish;
  }
  get languages() {
    return this.languageService.languages;
  }

  get selectedLanguage(): LanguageOption {
    return this.languageService.selectedLanguage;
  }
  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: false
    });
  }
}
